module.exports = __webpack_public_path__ + "img/external_link.c08b91fa.svg";